import React, {FC} from "react";
import {useIntl} from "react-intl";
import {PageTitle} from "../../../../_metronic/layout/core";
import WareHouseLog from "./ImportRequestHist";

const ImportRequestHistWrapper: FC = () => {
  const intl = useIntl();
  const breadcrumbs = [
    {
      title: intl.formatMessage({id: 'MENU.DASHBOARD'}),
      path: '/dashboard',
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    }
  ]

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Lịch sử nhập hàng</PageTitle>
      <WareHouseLog />
    </>
  )
}
export default ImportRequestHistWrapper;